module.exports = __webpack_public_path__ + "img/2.78f6dc00.jpg";